// Shared logo + gold diamond divider block, rendered at the top of every screen.
//   size="hero"    → full size (220px mobile / 320px desktop) — Login and OtpVerification
//   size="compact" → smaller (140px mobile / 180px desktop) — every other screen
export default function Header({ size }) {
  const hero = size === 'hero';
  return (
    <>
      {/* Logo */}
      <img
        src="/alfresco-grand.png"
        alt="Alfresco Grand"
        className={`${hero ? 'w-[220px] md:w-[320px]' : 'w-[140px] md:w-[180px]'} h-auto mix-blend-screen mb-6 logo-enter`}
      />

      {/* Ornamental diamond rule */}
      <div className={`flex items-center gap-3 ${hero ? 'mb-5' : 'mb-3'} ornament-enter w-full max-w-[260px]`}>
        <div className="flex-1 h-px bg-gradient-to-r from-transparent to-[rgba(212,168,67,0.4)]" />
        <div className="w-1.5 h-1.5 rotate-45 bg-[rgba(212,168,67,0.55)] shrink-0" />
        <div className="flex-1 h-px bg-gradient-to-l from-transparent to-[rgba(212,168,67,0.4)]" />
      </div>
    </>
  );
}
